import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Button from '../../../../../../incase-domain/components/button/Button';
import DropdownMenuCompact, {
    DropdownMenuCompactRef,
} from '../../../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import {selectedPresentationSelector} from '../../../../../../store/selectors/presentation.selectors';

type MenuBarReportsDropdownProps = {
    reportsMenuItemRef: React.RefObject<DropdownMenuCompactRef>;
    menuBarOpen: boolean;
    onHoverEnter: () => void;
    onMenuClose: () => void;
    onOpenMenuBar: () => void;
    mutateOnModified: (cb?: () => void) => void;
};

function MenuBarReportsDropdown({
    reportsMenuItemRef,
    menuBarOpen,
    onHoverEnter,
    onMenuClose,
    onOpenMenuBar,
    mutateOnModified,
}: MenuBarReportsDropdownProps): JSX.Element {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const selectedPresentation = useSelector(selectedPresentationSelector);

    const reportsMenuItems = useMemo(
        () => [
            [
                {
                    label: t('menuBar.reportsMenu.presentationStatistics'),
                    icon: 'solar:chart-bold',
                    onClick: () => mutateOnModified(() => navigate(`/presentations/${selectedPresentation._id}/report`)),
                },
            ],
        ],
        [t, mutateOnModified, navigate, selectedPresentation._id]
    );

    return (
        <DropdownMenuCompact
            ref={reportsMenuItemRef}
            openOnMouseEnter={menuBarOpen}
            onHoverEnter={onHoverEnter}
            onMenuClose={onMenuClose}
            items={reportsMenuItems}
        >
            <Button size="2xs" disableHover square variant="ghost" className="c-menuBar__button" onClick={onOpenMenuBar}>
                {t('menuBar.reports')}
            </Button>
        </DropdownMenuCompact>
    );
}

export default React.memo(MenuBarReportsDropdown);
